import React from 'react';

import {ValidationContextProvider} from 'src/contexts/validation-context';

import {FlatButton} from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {Icon, Icons} from '@pb/kit-component-icon';
import {useShown} from '@pb/kit-hooks-use-shown';


import {AddProjectCodeModal} from './add-project-code-modal';

import type {UserProjectCode} from 'src/openapi/admin/models/UserProjectCode';

type Props = {
    codes: UserProjectCode[],
    onCreate: (code: string) => void,
    disabled?: boolean,
};

export const AddProjectCodeDialog = ({codes, onCreate, disabled}: Props) => {
    const {onClick, onClose, shown} = useShown();

    return (
        <ValidationContextProvider>
            <FlatButton startIcon={<Icon type={Icons.PLUS}/>} disabled={disabled} onClick={onClick}>
                Add Project Code
            </FlatButton>
            <Dialog
                shown={shown}
                setShown={onClose}>
                <AddProjectCodeModal codes={codes} onCreate={onCreate} onClose={onClose}/>
            </Dialog>
        </ValidationContextProvider>
    );
};
